import React from 'react';
import ProcessingKaskoQuote from './ProcessingKaskoQuote';
import ProcessingCollisioneQuote from './ProcessingCollisioneQuote';
import ProcessingEventiPoliticiQuote from './ProcessingEventiPoliticiQuote';
import ProcessingEventiNaturaliQuote from './ProcessingEventiNaturaliQuote';
import ProcessingBonusProtettoQuote from './ProcessingBonusProtettoQuote';
import ProcessingFurtoIncendioQuote from './ProcessingFurtoIncendioQuote';
import ProcessingTutelaPrimaQuote from './ProcessingTutelaPrimaQuote';
import ProcessingAssistenzaPrimaQuote from './ProcessingAssistenzaPrimaQuote';
import ProcessingInfortuniPrimaQuote from './ProcessingInfortuniPrimaQuote';
import ProcessingCristalliPrimaQuote from './ProcessingCristalliPrimaQuote';
import ProcessingRivalsaPrimaQuote from './ProcessingRivalsaPrimaQuote';

function SelectedQuotesCardsPrimaBackoffice({ processingQuote, type }) {
  // Always suffix with `_prima` — the plain `type.id` collides with the
  // generic ModalQuotes' `id={type.id}` (rendered for every entry in the
  // server-provided quoteTypes list), which sits earlier in the DOM and
  // would otherwise "win" the data-bs-target lookup, opening an empty modal.
  const createIdForModal = () => `${type.id}_prima`;

  return (
    <>
      {processingQuote !== null && type.id === 'tutela_legale' && (
        <ProcessingTutelaPrimaQuote
          createIdForModal={createIdForModal}
          processingQuote={processingQuote}
          type={type}
        />
      )}

      {processingQuote !== null && type.id === 'assistenza_stradale' && (
        <ProcessingAssistenzaPrimaQuote
          createIdForModal={createIdForModal}
          processingQuote={processingQuote}
          type={type}
        />
      )}

      {processingQuote !== null && type.id === 'infortuni_conducente' && (
        <ProcessingInfortuniPrimaQuote
          createIdForModal={createIdForModal}
          processingQuote={processingQuote}
          type={type}
        />
      )}

      {processingQuote !== null && type.id === 'cristalli' && (
        <ProcessingCristalliPrimaQuote
          createIdForModal={createIdForModal}
          processingQuote={processingQuote}
          type={type}
        />
      )}

      {processingQuote !== null && type.id === 'protezione_rivalse' && (
        <ProcessingRivalsaPrimaQuote
          createIdForModal={createIdForModal}
          processingQuote={processingQuote}
          type={type}
        />
      )}

      {processingQuote !== null && type.id === 'kasko' && (
        <ProcessingKaskoQuote
          createIdForModal={createIdForModal}
          processingQuote={processingQuote}
          type={type}
        />
      )}

      {processingQuote !== null && type.id === 'collisione' && (
        <ProcessingCollisioneQuote
          createIdForModal={createIdForModal}
          processingQuote={processingQuote}
          type={type}
        />
      )}

      {processingQuote !== null && type.id === 'eventi_sociopolitici' && (
        <ProcessingEventiPoliticiQuote
          createIdForModal={createIdForModal}
          processingQuote={processingQuote}
          type={type}
        />
      )}

      {processingQuote !== null && type.id === 'eventi_naturali' && (
        <ProcessingEventiNaturaliQuote
          createIdForModal={createIdForModal}
          processingQuote={processingQuote}
          type={type}
        />
      )}

      {processingQuote !== null && type.id === 'bonus_protetto' && (
        <ProcessingBonusProtettoQuote
          createIdForModal={createIdForModal}
          processingQuote={processingQuote}
          type={type}
        />
      )}

      {processingQuote !== null && type.id === 'furto_incendio' && (
        <ProcessingFurtoIncendioQuote
          createIdForModal={createIdForModal}
          processingQuote={processingQuote}
          type={type}
        />
      )}
    </>
  );
}

export default SelectedQuotesCardsPrimaBackoffice;
